/**
 * @license
 * @copyright Copyright Motili Inc., 2018 All Rights Reserved
 */

module.exports = {
    path: '/m/order/shipping/:token',
    getComponent(nextState, callback) {
        require.ensure([], (require) => {
            callback(null, require('./ShippingContainer'));
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/components/order/order-shipping/route.OrderShipping.js